export default __webpack_public_path__ + "static/media/Login_Cards.171d55f3.svg";